module.exports = __webpack_public_path__ + "media/images/icon__email@2x-9a5363d3e6272bd6a2c610d207ca215c.png";